<template>
  <div
    v-if="show"
    ref="floatingEl"
    class="bg-primary z-10 py-2 px-4 rounded typography-body-1 text-white"
    :style="floatingStyles"
  >
    {{ content }}

    <div ref="arrowEl" class="bg-primary size-2 absolute rotate-45" :style="arrowStyle" />
  </div>
</template>

<script setup lang="ts">
import { arrow, autoPlacement, offset, useFloating } from '@floating-ui/vue'
import { onClickOutside } from '@vueuse/core'

const props = defineProps<{
  show?: boolean
  referenceElement: InstanceType<any>
  content: string
}>()

const emit = defineEmits<{
  close: [value: void]
}>()

const arrowEl = ref<HTMLDivElement>()
const floatingEl = ref<HTMLDivElement>()
const targetEl = ref<InstanceType<any>>(props.referenceElement)

const { floatingStyles, middlewareData } = useFloating(targetEl, floatingEl, {
  middleware: [
    offset(4),
    autoPlacement({
      allowedPlacements: ['top', 'bottom']
    }),
    arrow({
      element: arrowEl
    })
  ]
})

const arrowStyle = computed(() => {
  const arrow = middlewareData?.value?.arrow
  const offset = middlewareData?.value?.offset
  return {
    top: `${(arrow?.y ?? 0) - (offset?.y ?? 0)}px`,
    left: `${(arrow?.x ?? 0) - (offset?.x ?? 0)}px`,
    willChange: floatingStyles.value.willChange
  }
})

onClickOutside(floatingEl, (event) => {
  if (!event.composedPath().includes(targetEl.value?.$el)) {
    emit('close')
  }
})
</script>
